const X_BY_COUNT = {
    1: [24],
    2: [6, 24],
    3: [6, 15, 24],
};
const PLOT_TOP = 2;
const PLOT_BOTTOM = 14;
function canRenderSingleDot(submetric) {
    return ((submetric.previous_kit_count ?? 0) > 0 &&
        !submetric.previous_values_version_excluded &&
        typeof submetric.user_value === 'number');
}
export function calculatePreviewChartContext(submetric) {
    const min = submetric.gut_vaginal_health.scale_bar_min;
    const max = submetric.gut_vaginal_health.scale_bar_max;
    if (min === undefined || max === undefined || min === max)
        return { shouldRender: false };
    const rawPoints = [
        ...(submetric.previous_user_values ?? []),
        {
            user_value: submetric.user_value,
            evaluation_color: submetric.evaluation_color,
        },
    ].filter((p) => typeof p.user_value === 'number');
    if (rawPoints.length === 0)
        return { shouldRender: false };
    if (rawPoints.length === 1 && !canRenderSingleDot(submetric))
        return { shouldRender: false };
    const xPositions = X_BY_COUNT[rawPoints.length];
    if (!xPositions)
        return { shouldRender: false };
    const points = rawPoints.map((p, i) => {
        const clamped = Math.max(min, Math.min(max, p.user_value));
        const ratio = (clamped - min) / (max - min);
        return {
            x: xPositions[i],
            y: PLOT_BOTTOM - ratio * (PLOT_BOTTOM - PLOT_TOP),
            evaluation_color: p.evaluation_color,
        };
    });
    const linePoints = points.map(p => `${p.x},${p.y}`).join(' ');
    return { shouldRender: true, points, linePoints };
}
//# sourceMappingURL=calculatePreviewChartContext.js.map